class CountdownBar extends HTMLElement {
  connectedCallback() {
    this.endTime = parseInt(this.dataset.end, 10) || 0;
    this.cycle = (parseInt(this.dataset.cycle, 10) || 0) * 1000;
    this.pad = this.dataset.pad === 'true';
    this.showDays = this.dataset.showDays === 'true';
    this.showSeconds = this.dataset.showSeconds === 'true';
    this.onExpire = this.dataset.expire;
    this.designMode = this.dataset.designMode === 'true';

    this.timerEl = this.querySelector('[data-cdb-timer]');
    this.fields = {
      days: this.querySelector('[data-cdb-days]'),
      hours: this.querySelector('[data-cdb-hours]'),
      minutes: this.querySelector('[data-cdb-minutes]'),
      seconds: this.querySelector('[data-cdb-seconds]'),
    };

    this.lastMinutes = null;
    this.tick = this.tick.bind(this);
    this.handleVisibility = this.handleVisibility.bind(this);

    this.tick();
    this.interval = setInterval(this.tick, 1000);
    document.addEventListener('visibilitychange', this.handleVisibility);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  handleVisibility() {
    // Browsers throttle timers in background tabs — resync on return.
    if (!document.hidden) this.tick();
  }

  tick() {
    let remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      if (this.cycle > 0) {
        // Repeating timer: roll forward to the next cycle.
        const cycles = Math.floor(Math.abs(remaining) / this.cycle) + 1;
        this.endTime += cycles * this.cycle;
        remaining = this.endTime - Date.now();
      } else {
        this.render(0);
        this.expire();
        return;
      }
    }

    this.render(remaining);
  }

  render(remaining) {
    const total = Math.max(0, Math.floor(remaining / 1000));
    const days = Math.floor(total / 86400);
    const hours = this.showDays ? Math.floor((total % 86400) / 3600) : Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    this.set(this.fields.days, days);
    this.set(this.fields.hours, hours);
    this.set(this.fields.minutes, minutes);
    if (this.showSeconds) this.set(this.fields.seconds, seconds);

    if (this.timerEl && this.lastMinutes !== minutes) {
      this.lastMinutes = minutes;
      const parts = [];
      if (this.showDays && days > 0) parts.push(`${days} days`);
      parts.push(`${hours} hours`, `${minutes} minutes`);
      this.timerEl.setAttribute('aria-label', `Offer ends in ${parts.join(', ')}`);
    }
  }

  set(el, value) {
    if (!el) return;
    const next = this.pad ? String(value).padStart(2, '0') : String(value);
    if (el.textContent !== next) el.textContent = next;
  }

  expire() {
    clearInterval(this.interval);

    if (this.onExpire === 'zero') return;

    if (this.onExpire === 'message') {
      const template = this.querySelector('[data-cdb-expired-template]');
      const inner = this.querySelector('.countdown-bar__inner');
      if (!template || !inner) return;
      inner.replaceChildren(template.content.cloneNode(true));
      return;
    }

    // Default: hide the bar. Keep it visible in the theme editor so it stays editable.
    if (!this.designMode) {
      const section = this.closest('.countdown-bar-section') || this;
      section.setAttribute('hidden', '');
    }
  }
}

if (!customElements.get('countdown-bar')) {
  customElements.define('countdown-bar', CountdownBar);
}
